module.exports = __webpack_public_path__ + "static/media/SPELL.25d517b0.png";